import React, { useState } from 'react';
import { Modal } from './ui/Modal';
import { privacyContent, termsContent } from './legalContent';
type LegalDoc = 'privacy' | 'terms' | null;
export function Footer() {
  const [openDoc, setOpenDoc] = useState<LegalDoc>(null);
  return <footer className="py-10 text-center border-t border-zinc-900 px-4" data-id="element-38">
      <p className="text-sm text-zinc-600 mb-4" data-id="element-39">
        © {new Date().getFullYear()} Chakra Reset. Todos los derechos
        reservados.
      </p>
      <nav className="flex items-center justify-center gap-6 text-sm" data-id="element-40">
        <button onClick={() => setOpenDoc('privacy')} className="text-zinc-500 hover:text-zinc-200 transition-colors focus:outline-none focus-visible:ring-2 focus-visible:ring-purple-500/50 rounded" data-id="element-41">
          Política de Privacidad
        </button>
        <span className="text-zinc-700" aria-hidden="true" data-id="element-42">
          ·
        </span>
        <button onClick={() => setOpenDoc('terms')} className="text-zinc-500 hover:text-zinc-200 transition-colors focus:outline-none focus-visible:ring-2 focus-visible:ring-purple-500/50 rounded" data-id="element-43">
          Términos y Condiciones
        </button>
      </nav>

      <Modal isOpen={openDoc === 'privacy'} onClose={() => setOpenDoc(null)} title="Política de Privacidad" data-id="element-44">
        {privacyContent}
      </Modal>

      <Modal isOpen={openDoc === 'terms'} onClose={() => setOpenDoc(null)} title="Términos y Condiciones" data-id="element-45">
        {termsContent}
      </Modal>
    </footer>;
}